var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "lg",
      "opacity": "0.6",
      "spinner-variant": "primary"
    },
    scopedSlots: _vm._u([{
      key: "overlay",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-spinner', {
          attrs: {
            "small": "",
            "type": "grow",
            "variant": "secondary"
          }
        }), _c('b-spinner', {
          attrs: {
            "type": "grow",
            "variant": "dark"
          }
        }), _c('b-spinner', {
          attrs: {
            "small": "",
            "type": "grow",
            "variant": "secondary"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('b-row', {
    staticClass: "mt-4 create-new"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "to": {
        name: _vm.UserEbookManagePath.name
      }
    }
  }, [_c('em', {
    staticClass: "fa fa-backward"
  }), _vm._v(" Manage User Ebook ")])], 1), _c('b-col', [_c('b-form', {
    on: {
      "submit": _vm.onSubmit,
      "reset": _vm.onReset
    }
  }, [_c('div', {
    staticClass: "card mt-4"
  }, [_c('div', {
    staticClass: "bg-success p-3"
  }, [_c('h5', {
    staticClass: "card-title mb-0 font-weight-bold"
  }, [_vm._v(" Create New User Ebook ")])]), _c('div', {
    staticClass: "card-body"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "lg": "6"
    }
  }, [_c('b-card', {
    staticClass: "bg-info text-dark"
  }, [_vm._v("(*) Kolom berlabel bintang wajib diisi.")])], 1)], 1), _c('b-row', [_c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "lg": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Email *"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "input email",
      "id": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "lg": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Password *"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "password",
      "type": "password",
      "step": "any",
      "placeholder": "*********",
      "maxlength": "100",
      "required": ""
    },
    model: {
      value: _vm.form.password,
      callback: function ($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "lg": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Gender *"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "gender",
      "track-by": "value",
      "options": _vm.genderOptions,
      "required": ""
    },
    model: {
      value: _vm.form.gender,
      callback: function ($$v) {
        _vm.$set(_vm.form, "gender", $$v);
      },
      expression: "form.gender"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "lg": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "First Name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "first_name",
      "type": "text",
      "step": "any",
      "placeholder": "input first name"
    },
    model: {
      value: _vm.form.first_name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "first_name", $$v);
      },
      expression: "form.first_name"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "lg": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Last Name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "last_name",
      "type": "text",
      "step": "any",
      "placeholder": "input last name"
    },
    model: {
      value: _vm.form.last_name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "last_name", $$v);
      },
      expression: "form.last_name"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "lg": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Phone Number"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "phone_number",
      "type": "text",
      "step": "any",
      "placeholder": "input phone number"
    },
    model: {
      value: _vm.form.phone_number,
      callback: function ($$v) {
        _vm.$set(_vm.form, "phone_number", $$v);
      },
      expression: "form.phone_number"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "lg": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Birthdate"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "birthdate",
      "type": "date"
    },
    model: {
      value: _vm.form.birthdate,
      callback: function ($$v) {
        _vm.$set(_vm.form, "birthdate", $$v);
      },
      expression: "form.birthdate"
    }
  })], 1)], 1)], 1), _c('br'), _c('b-row', [_c('b-col', [_c('b-button', {
    attrs: {
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm._v("create")])], 1)], 1)], 1)])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }